import React from 'react';
import { connect } from 'react-redux';

import classNames from './../../utils/classNames';
import formatTime from './../../utils/formatTime';

import Icon from './../Icon';

const UserInfo = props => {
    const { message } = props;
    const sender = message.sender_role;
    switch (sender) {
        case 'writer':
            return (
                <div className="chat-user-info">
                    <i className="chat-user-type type-writer"></i>
                    <h4 className="chat-user-name">Writer</h4>
                </div>
            );
        case 'grader':
        case 'pregrader':
            return (
                <div className="chat-user-info">
                    <h4 className="chat-user-name"><span>Me</span></h4>
                </div>
            );
        case 'operator':
            return (
                <div className="chat-user-info">
                    <i className="chat-user-type type-operator"></i>
                    <h4 className="chat-user-name">Operator</h4>
                </div>
            );
        case 'client':
            return (
                <div className="chat-user-info">
                    <i className="chat-user-type type-client"></i>
                    <h4 className="chat-user-name">Client</h4>
                </div>
            );
        default:
            return (
                <div className="chat-user-info">
                    <i className="chat-user-type type-system"></i>
                    <h4 className="chat-user-name">System</h4>
                </div>
            );
    }
};

const ConfirmButton = props => {
    const { message, setRead } = props;
    const isMe = message.sender_role === 'pregrader';
    const isToMe = message.recepient_role === 'pregrader';
    const disabled = message.isFetchingRead;
    if (isMe || !isToMe) {
        return null;
    }
    if (message.confirm_status === 'need_confirm') {
        return (
            <button className="btn btn-empty btn-confirm" disabled={disabled} onClick={() => setRead(message._id)}>Confirm</button>
        );
    }
    if (message.status === 'unread') {
        return (
            <button className="btn btn-empty btn-confirm" disabled={disabled} onClick={() => setRead(message._id)}>Mark as read</button>
        );
    }
    if (message.confirm_status === 'confirmed') {
        return (
            <div className="col-1 text-success">
                <Icon className="svg-icon" iconName="check" />
                Confirmed
            </div>
        );
    }
    if (message.status === 'read') {
        return (
            <div className="col-1 text-success">
                <Icon className="svg-icon" iconName="check" />
                Read
            </div>
        );
    }
    return null;
};

const FileBox = props => {
    const { file } = props;
    if (!file) {
        return null;
    }
    const fileUrl = file.location;
    const parts = fileUrl.split('/').pop().split('.');
    const ext = parts.length > 1 ? parts.pop() : '';
    const className = ext === 'pdf' || ext === 'docx' || ext === 'pptx'
        ? ext + '-icon file-icon upload-file'
        : 'file-icon paper-icon upload-file';

    return (
        <div className={className}><a href={file.location} target="_blank" rel="noopener noreferrer">{file.name}</a></div>
    );
};

const MessageRow = props => {
    // const { message, setRead, fileItems } = props;
    const { message, setRead } = props;
    const isMe = message.sender_role === 'pregrader';
    const className = classNames('chat-item', { 'chat-item-in': !isMe });

    return (
        <div className={className}>
            <div className="chat-message-wrap">
                <UserInfo message={message} />
                <div className="chat-message">
                    {!!message.message &&
                        <p className="chat-message-text">{message.message}</p>
                    }
                    {/* {!!message.attachment && !!message.attachment.length && message.attachment.map(attId => */}
                    {!!message.files && !!message.files.length && message.files.map(file =>
                        // <FileBox file={fileItems[attId]} key={attId} />
                        <FileBox file={file} key={file._id} />
                    )}
                </div>
                <div className="row space-between vertical">
                    {!isMe &&
                        <div className="col-1">
                            <ConfirmButton message={message} setRead={setRead} />
                        </div>
                    }
                    <div className="col-1">
                        <span className="chat-time">
                            {formatTime(message.created_at, 'dt')} <span>({message.recepient_role})</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

const OrderTabMessages = props => {
    // const { messageList, setRead, fileItems, myUserId } = props;
    const { messageList, setRead, myUserId } = props;
    return (
        <div className="chat-box">
            <div className="chat-item-list">
                {messageList.filter(message => message.status !== 'hidden').map(message =>
                    // <MessageRow key={message._id} message={message} setRead={setRead} fileItems={fileItems} myUserId={myUserId} />
                    <MessageRow key={message._id} message={message} setRead={setRead} myUserId={myUserId} />
                )}
            </div>
        </div>
    );
};

const mapStateToProps = state => {
    return { myUserId: state.user._id }
};

export default connect(mapStateToProps)(OrderTabMessages);



// WEBPACK FOOTER //
// ./src/components/order/OrderTabMessages.js